export default "__VITE_ASSET__BWypG0ht__"